// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 605) return "static/chunks/605-ed013b92c36cf1ee.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "dab40e539c9d22d4" + ".js";
};